module.exports = __webpack_public_path__ + "img/nosotros.8c5baa2f.jpg";